<template>
    <div class="auctionList">
        <div class="listGood listView borderLRB">
            <ul>
                <li v-for="(item,index) in auctionLists" :key="index">
                    <div class="item fix">
                        <div class="dateBox fl">
                            <div class="date">
                                <div class="yearNum verdanF12">{{ item.pc_extra_info[12].text.split('-')[0] }}</div>
                                <div class="dateNum">{{ item.pc_extra_info[12].text.split('-')[1] }}</div>
                            </div>
                        </div>
                        <div class="infoBox fl">
                            <a class="auctionFont color333 fontLine" target="_blank" @click="handleRouter(item)">{{ item.name }}</a>
                            <div class="info fontSong12">
                                拍卖时间：
                                <span class="color333">{{ item.pc_extra_info[12].text }}</span>
                            </div>
                            <div class="info fontSong12">
                                拍卖地点：
                                <span class="color333">{{ item.pc_extra_info[13].text }}</span>
                            </div>
                            <div class="info fontSong12">
                                拍卖专场：
                                <span class="color333">{{ item.pc_extra_info[6].text ? item.pc_extra_info[6].text : 0 }}个专场</span>
                            </div>
                        </div>
                        <div class="priceBox fr">
                            <div class="rate font14 fontLine yahei color999">
                                成交额：<span class="red verdanF14">{{ item.pc_extra_info[14].text }}</span>
                            </div>
                            <div class="rate font14 fontLine yahei color999">
                                成交率：<span class="red verdanF14">{{ item.pc_extra_info[9].text }}</span>
                            </div>
                        </div>
                    </div>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
export default {
    name: "auctionList",
    props: ['auctionLists'],
    data(){
        return{
            dataList:[{},{}],
        }
    },
    methods: {
        handleRouter(item) {
            console.log(item.sessionCode);
            this.$router.push(`/meeting_detail/${item.sessionCode}`)
        }
    }
}
</script>

<style scoped lang="scss">
@import '@/assets/css/auctionCompany.scss';
.auctionList{
    ul{
        li{
            .date{
                width: 80px;
                height: 90px;
                .yearNum{
                    background: #ccc;
                    color: #fff;
                    height: 20px;
                    line-height: 18px;
                    text-align: center;
                    font-size: 13px;
                }
                .dateNum{
                    width: 80px;
                    height: 70px;
                    font: 36px/69px Verdana;
                    border-right: 1px solid #e6e6e6;
                    border-left: 1px solid #e6e6e6;
                    border-bottom: 1px solid #e6e6e6;
                    text-align: center;
                    color: #999;
                    font-weight: bold;
                    background: #fff;
                }
            }
            .infoBox{
                margin-top: 0px;
            }
            &:hover .date{
                .yearNum{
                    background: #333333;
                }
                .dateNum{
                    background: #fff;
                    color: #333;
                    border-right: 1px solid #333;
                    border-left: 1px solid #333;
                    border-bottom: 1px solid #333;
                }
            }
        }
    }

}
</style>